import React from "react";
import "./FilterSidebar.css";

import { Link } from "react-router-dom"; //Link
import Accordion from "react-bootstrap/Accordion";

export default function FilterSidebar({ open, setOpen }) {
  return (
    <>
    <div className={`base ${open ? "active" : ""}`}>
    
    <div className="sidebar_filter_main">
        <div className="sidebar_filter_header">
          <h1>Filters</h1>
          <button className="close_btn" onClick={() => setOpen(false)}>
            ✕
          </button>
        </div>
        <div className="filter_accord">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Size</Accordion.Header>
              <Accordion.Body>
                <div className="filter_check_outer">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault"
                    />
                    <label class="form-check-label" for="checkDefault">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault1"
                    />
                    <label class="form-check-label" for="checkDefault1">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault2"
                    />
                    <label class="form-check-label" for="checkDefault2">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault3"
                    />
                    <label class="form-check-label" for="checkDefault3">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault4"
                    />
                    <label class="form-check-label" for="checkDefault4">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Material</Accordion.Header>
              <Accordion.Body>
                <div className="filter_check_outer">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault19"
                    />
                    <label class="form-check-label" for="checkDefault19">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault20"
                    />
                    <label class="form-check-label" for="checkDefault20">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault21"
                    />
                    <label class="form-check-label" for="checkDefault21">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault22"
                    />
                    <label class="form-check-label" for="checkDefault22">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault23"
                    />
                    <label class="form-check-label" for="checkDefault23">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Pattern</Accordion.Header>
              <Accordion.Body>
                <div className="filter_check_outer">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault24"
                    />
                    <label class="form-check-label" for="checkDefault24">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault25"
                    />
                    <label class="form-check-label" for="checkDefault25">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault6"
                    />
                    <label class="form-check-label" for="checkDefault6">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault7"
                    />
                    <label class="form-check-label" for="checkDefault7">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault8"
                    />
                    <label class="form-check-label" for="checkDefault8">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>Color</Accordion.Header>
              <Accordion.Body>
                <div className="filter_check_outer">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault9"
                    />
                    <label class="form-check-label" for="checkDefault9">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault10"
                    />
                    <label class="form-check-label" for="checkDefault10">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault11"
                    />
                    <label class="form-check-label" for="checkDefault11">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault12"
                    />
                    <label class="form-check-label" for="checkDefault12">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault13"
                    />
                    <label class="form-check-label" for="checkDefault13">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>Collection</Accordion.Header>
              <Accordion.Body>
                <div className="filter_check_outer">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault14"
                    />
                    <label class="form-check-label" for="checkDefault14">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault15"
                    />
                    <label class="form-check-label" for="checkDefault15">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault16"
                    />
                    <label class="form-check-label" for="checkDefault16">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault17"
                    />
                    <label class="form-check-label" for="checkDefault17">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkDefault18"
                    />
                    <label class="form-check-label" for="checkDefault18">
                      11x6ft <span>(0)</span>
                    </label>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>Price</Accordion.Header>
              <Accordion.Body>
                <div className="price_range_outer">
                  <input
                    type="range"
                    class="form-range"
                    min="0"
                    max="5"
                    id="range2"
                  ></input>
                  <label for="range2" class="form-label">
                    ₹INR 5000 to 8000
                  </label>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <a href="" className="apply_filter_btn">
            Apply Filter
          </a>
        </div>
      </div>
    </div>
      
    </>
  );
}
